module.exports = __webpack_public_path__ + "static/ec-dor-mobile-187a46f0435e05215e9d04e4d8dcb715.png";